/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./js/sections/landing-page-healing-timeline.js":
/*!******************************************************!*\
  !*** ./js/sections/landing-page-healing-timeline.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _scss_sections_landing_page_healing_timeline_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../scss/sections/landing-page-healing-timeline.scss */ "./scss/sections/landing-page-healing-timeline.scss");
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! gsap */ "./node_modules/gsap/index.js");
/* harmony import */ var gsap_ScrollTrigger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! gsap/ScrollTrigger */ "./node_modules/gsap/ScrollTrigger.js");
// This entry shares its name with the section's SCSS entry, so webpack keeps
// only one of them — import the styles here so the CSS still gets emitted.



gsap__WEBPACK_IMPORTED_MODULE_1__["default"].registerPlugin(gsap_ScrollTrigger__WEBPACK_IMPORTED_MODULE_2__.ScrollTrigger);
const SELECTORS = {
  section: "[data-healing-timeline]",
  header: "[data-ht-header]",
  mobileImage: "[data-ht-mobile-image]",
  timeline: "[data-ht-timeline]",
  lineTrack: "[data-ht-line-track]",
  lineProgress: "[data-ht-line-progress]",
  milestone: "[data-ht-milestone]",
  dot: "[data-ht-dot]",
  howToUse: "[data-ht-how-to-use]",
  circle: "[data-ht-circle]",
  star: "[data-ht-star]",
  videoBox: "[data-ht-video-box]",
  muteBtn: "[data-ht-mute]",
  playPauseBtn: "[data-ht-playpause]"
};

/**
 * Wire a single video element to its custom pill controls.
 * Sets initial UI state from the element, syncs on native events.
 */
function initVideoControls(videoBox) {
  const video = videoBox.querySelector("video");
  const muteBtn = videoBox.querySelector(SELECTORS.muteBtn);
  const playBtn = videoBox.querySelector(SELECTORS.playPauseBtn);
  if (!video) return;
  const syncMute = () => {
    if (!muteBtn) return;
    const muted = video.muted;
    muteBtn.classList.toggle("is-muted", muted);
    muteBtn.setAttribute("aria-pressed", muted ? "true" : "false");
    muteBtn.setAttribute("aria-label", muted ? "Unmute video" : "Mute video");
  };
  const syncPlay = () => {
    if (!playBtn) return;
    const playing = !video.paused && !video.ended;
    playBtn.classList.toggle("is-playing", playing);
    playBtn.setAttribute("aria-pressed", playing ? "true" : "false");
    playBtn.setAttribute("aria-label", playing ? "Pause video" : "Play video");
  };
  if (muteBtn) {
    muteBtn.addEventListener("click", () => {
      video.muted = !video.muted;
      /* Unmuting a muted autoplaying video sometimes requires a play() retry */
      if (!video.muted && video.paused) {
        video.play().catch(() => {});
      }
      syncMute();
    });
  }
  const togglePlay = () => {
    if (video.paused) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
    syncPlay();
  };
  if (playBtn) {
    playBtn.addEventListener("click", togglePlay);
  }

  /* Click anywhere on video toggles play/pause. Buttons sit on a sibling
     overlay so their clicks never bubble through the video element. */
  video.addEventListener("click", togglePlay);
  video.addEventListener("play", syncPlay);
  video.addEventListener("pause", syncPlay);
  video.addEventListener("ended", syncPlay);
  video.addEventListener("volumechange", syncMute);
  syncMute();
  syncPlay();
}
const BP_DESKTOP = "(min-width: 1024px)";
const BP_MOBILE = "(max-width: 1023px)";

/**
 * Issue #5: Calculate line-track bounds so it starts at first dot
 * center and ends at last dot center (no line above first / below last).
 */
function setLineTrackBounds(timeline, lineTrack, dots) {
  if (!lineTrack || dots.length < 2) return;
  const timelineRect = timeline.getBoundingClientRect();
  const firstDot = dots[0];
  const lastDot = dots[dots.length - 1];
  const firstDotRect = firstDot.getBoundingClientRect();
  const lastDotRect = lastDot.getBoundingClientRect();
  const topOffset = firstDotRect.top + firstDotRect.height / 2 - timelineRect.top;
  const bottomOffset = timelineRect.bottom - (lastDotRect.top + lastDotRect.height / 2);
  timeline.style.setProperty("--ht-line-top", `${topOffset}px`);
  timeline.style.setProperty("--ht-line-bottom", `${bottomOffset}px`);
}

/**
 * Issue #8: Determine which milestones are "active" based on the
 * scroll-linked line progress reaching their dot position.
 */
function getActiveMilestoneIndex(progress, dots, timeline) {
  if (!dots.length) return -1;
  const timelineRect = timeline.getBoundingClientRect();
  const firstDotCenter = dots[0].getBoundingClientRect().top + dots[0].getBoundingClientRect().height / 2 - timelineRect.top;
  const lastDotCenter = dots[dots.length - 1].getBoundingClientRect().top + dots[dots.length - 1].getBoundingClientRect().height / 2 - timelineRect.top;
  const totalLineHeight = lastDotCenter - firstDotCenter;
  if (totalLineHeight <= 0) return -1;
  const currentLinePos = firstDotCenter + progress * totalLineHeight;
  let activeIndex = -1;
  dots.forEach((dot, i) => {
    const dotCenter = dot.getBoundingClientRect().top + dot.getBoundingClientRect().height / 2 - timelineRect.top;
    if (currentLinePos >= dotCenter - 2) {
      activeIndex = i;
    }
  });
  return activeIndex;
}
function initHealingTimeline() {
  const sections = document.querySelectorAll(SELECTORS.section);
  if (!sections.length) return;
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  sections.forEach(section => {
    const timeline = section.querySelector(SELECTORS.timeline);
    const lineTrack = section.querySelector(SELECTORS.lineTrack);
    const lineProgress = section.querySelector(SELECTORS.lineProgress);
    const milestones = section.querySelectorAll(SELECTORS.milestone);
    const dots = section.querySelectorAll(SELECTORS.dot);
    const header = section.querySelector(SELECTORS.header);
    const mobileImage = section.querySelector(SELECTORS.mobileImage);
    const howToUse = section.querySelector(SELECTORS.howToUse);
    const circles = section.querySelectorAll(SELECTORS.circle);
    const star = section.querySelector(SELECTORS.star);

    /* Custom video controls — wire all video boxes in this section */
    section.querySelectorAll(SELECTORS.videoBox).forEach(box => initVideoControls(box));

    /* Play/pause videos based on video-box viewport visibility */
    const videoBoxes = section.querySelectorAll(SELECTORS.videoBox);
    if (videoBoxes.length) {
      const videoObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const video = entry.target.querySelector("video");
          if (!video) return;
          if (entry.isIntersecting) {
            entry.target.setAttribute("data-video-state", "play");
            video.play().catch(() => {});
          } else {
            entry.target.setAttribute("data-video-state", "pause");
            video.pause();
          }
        });
      }, {
        threshold: 0.1
      });
      videoBoxes.forEach(box => videoObserver.observe(box));
    }
    if (!timeline || !milestones.length) return;

    /* Issue #5: set line bounds immediately + on resize */
    setLineTrackBounds(timeline, lineTrack, dots);
    const resizeObserver = new ResizeObserver(() => {
      setLineTrackBounds(timeline, lineTrack, dots);
    });
    resizeObserver.observe(timeline);

    /* Reduced-motion: show everything, skip animations */
    if (prefersReducedMotion) {
      if (header) gsap__WEBPACK_IMPORTED_MODULE_1__["default"].set(header, {
        opacity: 1,
        y: 0
      });
      milestones.forEach(m => m.classList.add("is-active"));
      section.querySelectorAll(".healing-timeline__dot-inner").forEach(d => gsap__WEBPACK_IMPORTED_MODULE_1__["default"].set(d, {
        scale: 1
      }));
      if (howToUse) gsap__WEBPACK_IMPORTED_MODULE_1__["default"].set(howToUse, {
        opacity: 1,
        y: 0
      });
      if (lineProgress) gsap__WEBPACK_IMPORTED_MODULE_1__["default"].set(lineProgress, {
        scaleY: 1
      });
      gsap__WEBPACK_IMPORTED_MODULE_1__["default"].set(circles, {
        opacity: 1
      });
      return;
    }
    const mm = gsap__WEBPACK_IMPORTED_MODULE_1__["default"].matchMedia();

    /* ─── Header fade-in ─── */
    if (header) {
      gsap__WEBPACK_IMPORTED_MODULE_1__["default"].fromTo(header, {
        opacity: 0,
        y: 40
      }, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power2.out",
        scrollTrigger: {
          trigger: header,
          start: "top 85%",
          toggleActions: "play none none none"
        }
      });
    }

    /* ─── Mobile video fade-in ─── */
    if (mobileImage) {
      gsap__WEBPACK_IMPORTED_MODULE_1__["default"].fromTo(mobileImage, {
        opacity: 0,
        scale: 0.9
      }, {
        opacity: 1,
        scale: 1,
        duration: 0.8,
        ease: "power2.out",
        scrollTrigger: {
          trigger: mobileImage,
          start: "top 85%",
          toggleActions: "play none none none"
        }
      });
    }

    /* ─── Scale dots in when their milestone enters viewport ─── */
    milestones.forEach(milestone => {
      const dot = milestone.querySelector(SELECTORS.dot);
      const dotInner = dot ? dot.querySelector(".healing-timeline__dot-inner") : null;
      if (dotInner) {
        gsap_ScrollTrigger__WEBPACK_IMPORTED_MODULE_2__.ScrollTrigger.create({
          trigger: milestone,
          start: "top 78%",
          once: true,
          onEnter: () => {
            gsap__WEBPACK_IMPORTED_MODULE_1__["default"].to(dotInner, {
              scale: 1,
              duration: 0.4,
              ease: "back.out(2)"
            });
          }
        });
      }
    });

    /* ─── Issue #5 + #8: scroll-linked line progress + milestone activation ─── */
    if (lineProgress) {
      gsap__WEBPACK_IMPORTED_MODULE_1__["default"].set(lineProgress, {
        scaleY: 0,
        transformOrigin: "top center"
      });
      gsap_ScrollTrigger__WEBPACK_IMPORTED_MODULE_2__.ScrollTrigger.create({
        trigger: timeline,
        start: "top 70%",
        end: "bottom 70%",
        scrub: 0.3,
        onUpdate: self => {
          /* Update line progress */
          gsap__WEBPACK_IMPORTED_MODULE_1__["default"].set(lineProgress, {
            scaleY: self.progress
          });

          /* Issue #8: activate milestones as line reaches their dot */
          const activeIdx = getActiveMilestoneIndex(self.progress, dots, timeline);
          milestones.forEach((m, i) => {
            if (i <= activeIdx) {
              m.classList.add("is-active");
            } else {
              m.classList.remove("is-active");
            }
          });
        }
      });
    }

    /* ─── How to use card ─── */
    if (howToUse) {
      gsap__WEBPACK_IMPORTED_MODULE_1__["default"].to(howToUse, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: "power2.out",
        scrollTrigger: {
          trigger: howToUse,
          start: "top 85%",
          toggleActions: "play none none none"
        }
      });
    }

    /* ─── Desktop: right column media ─── */
    mm.add(BP_DESKTOP, () => {
      if (circles.length) {
        circles.forEach((circle, i) => {
          /* Skip video box (data-ht-circle="1") — no animation */
          if (circle.dataset.htCircle === "1") return;
          gsap__WEBPACK_IMPORTED_MODULE_1__["default"].fromTo(circle, {
            opacity: 0,
            scale: 0.85,
            y: 50 + i * 20
          }, {
            opacity: 1,
            scale: 1,
            y: 0,
            duration: 1,
            ease: "power3.out",
            delay: i * 0.15,
            scrollTrigger: {
              trigger: circle,
              start: "top 85%",
              toggleActions: "play none none none"
            }
          });
        });
      }

      /* Star rotation */
      if (star) {
        gsap__WEBPACK_IMPORTED_MODULE_1__["default"].fromTo(star, {
          opacity: 0,
          rotation: -90,
          scale: 0
        }, {
          opacity: 1,
          rotation: 0,
          scale: 1,
          duration: 1,
          ease: "back.out(2)",
          scrollTrigger: {
            trigger: star,
            start: "top 80%",
            toggleActions: "play none none none"
          }
        });
      }
    });

    /* ─── Mobile: bottom images ─── */
    mm.add(BP_MOBILE, () => {
      const mobileBottomContainer = section.querySelector(".healing-timeline__mobile-bottom-images");
      if (!mobileBottomContainer) return;
      const mobileBottomImages = mobileBottomContainer.querySelectorAll(".healing-timeline__rect-image, .healing-timeline__circle-image");
      if (!mobileBottomImages.length) return;
      gsap__WEBPACK_IMPORTED_MODULE_1__["default"].fromTo(mobileBottomImages, {
        opacity: 0,
        scale: 0.85,
        y: 30
      }, {
        opacity: 1,
        scale: 1,
        y: 0,
        duration: 0.8,
        ease: "power2.out",
        stagger: 0.15,
        scrollTrigger: {
          trigger: mobileBottomContainer,
          start: "top 85%",
          toggleActions: "play none none none"
        }
      });
    });

    /* ─── Cleanup for Shopify theme editor ─── */
    const handleSectionUnload = e => {
      if (!section.contains(e.target) && e.target !== section) return;
      mm.revert();
      resizeObserver.disconnect();
      gsap_ScrollTrigger__WEBPACK_IMPORTED_MODULE_2__.ScrollTrigger.getAll().filter(st => st.trigger && section.contains(st.trigger)).forEach(st => st.kill());
      document.removeEventListener("shopify:section:unload", handleSectionUnload);
    };
    document.addEventListener("shopify:section:unload", handleSectionUnload);
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initHealingTimeline);
} else {
  initHealingTimeline();
}

/***/ }),

/***/ "./scss/sections/landing-page-healing-timeline.scss":
/*!**********************************************************!*\
  !*** ./scss/sections/landing-page-healing-timeline.scss ***!
  \**********************************************************/
/***/ (() => {

// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"landing-page-healing-timeline": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["vendor-gsap"], () => (__webpack_require__("./js/sections/landing-page-healing-timeline.js")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;